import { Box, Grid } from "@mui/material";
import React from "react";
import { DialogSectionCard } from "source/components/framework/Dialog/DialogSectionCard";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import { ISessionState } from "../../../../../models/session/sessionState";
import { FormDesignerBuilderFormBuilder, FormDesignerDataRow } from "./FormDesignerBuilderFormBuilder";
import { FormDesignerBuilderRowBuilder } from "./FormDesignerBuilderRowBuilder";
import { FormAccordion } from "source/components/framework/FormAccordion";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";
import { FormDesignBuilderDroppableId } from "../../FormDesignerTypes";
import { FormDesignerBuilderRowOptionsDialog } from "./FormDesignerBuilderRowOptionsDialog";
import { SettingsToolButton } from "source/components/framework/Button/SettingsToolButton/SettingsToolButton";

interface IFormDesignerBuilderProps {
    taskType?: ITaskEditTypeItem;
    headerDesignerRows?: FormDesignerDataRow[];
    formDesignerRows?: FormDesignerDataRow[];
    headerDataRow?: ITaskDataRow;
    formDataRow?: ITaskDataRow;
    lineDataRow?: ITaskDataRow;
    headerTypeCol: ITaskTypeCol;
    formTypeCol: ITaskTypeCol;
    lineTypeCol: ITaskTypeCol;
    sessionState: ISessionState;
    draggingWidth?: number;
    draggingSource?: string;
    onHeaderItemClick?: (id: string) => void;
    onFormItemClick?: (id: string) => void;
    onHeaderRemoveComponent: (id: string) => void;
    onHeaderCopyComponent: (id: string) => void;
    onFormRemoveComponent: (id: string) => void;
    onFormCopyComponent: (id: string) => void;
    onViewSchema: () => void;
    onRemoveFieldFromLine: (id: string) => void;
    onAddFieldToLine: (id: string) => Promise<void>;
}

export const FormDesignerBuilder = (props: IFormDesignerBuilderProps) => {
    const [showRowOptions, setShowRowOptions] = React.useState(false);

    const hasHeader = !!props.taskType?.headerCols?.length;
    const hasLine = !!props.taskType?.lineCols?.length;
    
    return (
        <DialogSectionCard
            width="100%"
            headerTitle={Translations.DesignArea}
            buttons={props.sessionState?.isSuperAdmin
                ? <AppButton size="small" variant="outlined" onClick={props.onViewSchema}>{Translations.ShowSchema}</AppButton>
                : null
            }
            contentPadding="16px 0!important"
        >
            <Grid sx={{
                overflowY: "auto",
                overflowX: "hidden",
                height: "calc(100vh - 350px)",
                paddingLeft: "0",
                paddingRight: "0"
            }}>
                <FormAccordion
                    defaultExpanded={hasHeader}
                    title={Translations.Header}
                >
                    <FormDesignerBuilderFormBuilder
                        droppableId={FormDesignBuilderDroppableId.Header}
                        pickerDroppableId={FormDesignBuilderDroppableId.Picker}
                        designerRows={props.headerDesignerRows}
                        taskDataRow={props.headerDataRow}
                        taskTypeCol={props.headerTypeCol}
                        taskTypeCols={props.taskType?.headerCols ?? []}
                        draggingWidth={props.draggingWidth}
                        draggingSource={props.draggingSource}
                        onClick={props.onHeaderItemClick}
                        onRemoveComponent={props.onHeaderRemoveComponent}
                        onCopyComponent={props.onHeaderCopyComponent}

                    />
                </FormAccordion>
                <FormAccordion
                    defaultExpanded={true}
                    title={Translations.Contents}
                >
                    <FormDesignerBuilderFormBuilder
                        droppableId={FormDesignBuilderDroppableId.Form}
                        pickerDroppableId={FormDesignBuilderDroppableId.Picker}
                        designerRows={props.formDesignerRows}
                        taskDataRow={props.formDataRow}
                        taskTypeCol={props.formTypeCol}
                        taskTypeCols={props.taskType?.formCols ?? []}
                        draggingWidth={props.draggingWidth}
                        draggingSource={props.draggingSource}
                        onClick={props.onFormItemClick}
                        onRemoveComponent={props.onFormRemoveComponent}
                        onCopyComponent={props.onFormCopyComponent}

                    />
                </FormAccordion>
                {hasLine &&
                    <FormAccordion
                        defaultExpanded={true}
                        title={<Box display="flex" width="100%" alignItems="center">
                            <Box>{Translations.Line}</Box>
                            <SettingsToolButton
                                sx={{ marginLeft: ".5rem", marginTop: "-.5rem", marginBottom: "-.5rem" }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setShowRowOptions(true);
                                }}
                            />
                        </Box>}
                    >
                        <FormDesignerBuilderRowBuilder
                            droppableId={FormDesignBuilderDroppableId.Row}
                            taskType={props.taskType}
                            lineDataRow={props.lineDataRow}
                            lineTypeCol={props.lineTypeCol}
                            draggingSource={props.draggingSource}
                            onClick={props.onFormItemClick}
                        />
                    </FormAccordion>
                }
                {showRowOptions &&
                    <FormDesignerBuilderRowOptionsDialog
                        lineCols={props.taskType?.lineCols}
                        onAddFieldToLine={props.onAddFieldToLine}
                        onRemoveFieldFromLine={props.onRemoveFieldFromLine}
                        onClose={() => setShowRowOptions(false)}
                    />
                }
            </Grid>
        </DialogSectionCard>
    );
};
